import { Transaction } from "@/types/tx";
import { makeLoadableSlice } from "./common";

const { slice, selector } = makeLoadableSlice<Transaction[] | undefined>("txQueue", undefined);

export const txQueueSlice = slice;
export const selectTxQueue = selector;
